// src/components/SEOHelmet.js
import React from "react";
import { Helmet } from "react-helmet";

const SEOHelmet = ({
  title = "Home | Smarter Healthcare Claims Automation",
  description = "Canvendor simplifies healthcare claims with AI-powered automation. Reduce errors, cut costs, and speed up processing for hospitals, insurers, and patients.",
  keywords = "Canvendor, healthcare claims, AI automation, hospital billing, insurance processing, claims management",
  url = "https://www.canvendor.com/",
  image = "/assets/canvendor_transparent_logo.png",
  alt = "Canvendor Images",
  author = "Canvendor Team",
  jsonLd,
}) => {
  return (
    <Helmet>
      {/* Title & Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content={author} />

      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:image:alt" content={alt} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:creator" content="@Canvendor" />

      {/* ✅ Canonical URL */}
      <link rel="canonical" href={url} />

      {/* 👇 JSON-LD structured data (only if provided) */}
      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
};

export default SEOHelmet;
